module.exports = __webpack_public_path__ + "img/play.7ee37c44.svg";